import React from 'react'
import { Link } from "react-router-dom";


const Activities = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Activities</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active" style={{ color: "red" }}>Activities</li>
                    </ul>
                </div>
            </div>


            <div className="facility-area py-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline"><i className="far fa-book-open-reader" /> Our Activities</span>
                                <h2 className="site-title">Let's Check Our Activities</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-lg-4">
                            <div className="facility-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="facility-img">
                                    <img src="assets/school/Sports and Athletics.avif" alt />
                                </div>
                                <div className="facility-content">
                                    <h3 className="facility-title">
                                        <a to="#">Sports and Athletics</a>
                                    </h3>
                                    <p className="facility-text" style={{textAlign:"justify"}}>
                                        We provide excellent sports facilities and encourage every student to actively participate in indoor and outdoor games. Regular physical training sessions, inter-house competitions, and annual sports events help students develop strength, agility, leadership qualities, and a competitive spirit.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="facility-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="facility-img">
                                    <img src="assets/school/Arts and Culture.avif" alt />
                                </div>
                                <div className="facility-content">
                                    <h3 className="facility-title">
                                        <a to="#">Arts and Culture</a>
                                    </h3>
                                    <p className="facility-text" style={{textAlign:"justify"}}>
                                        At our school, Arts and Culture play a vital role in nurturing creativity, confidence, and a deep appreciation for India’s rich heritage. We believe that education is complete only when academic learning is balanced with artistic expression and cultural values.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="facility-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="facility-img">
                                    <img src="assets/school/Clubs and Societies.jpg" alt />
                                </div>
                                <div className="facility-content">
                                    <h3 className="facility-title">
                                        <a to="#">Clubs and Societies</a>
                                    </h3>
                                    <p className="facility-text" style={{textAlign:"justify"}}>
                                        At our school, Clubs and Societies play an important role in the all-round development of students. They provide opportunities beyond academics to explore interests, build confidence, develop leadership skills, and encourage teamwork.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="facility-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="facility-img">
                                    <img src="assets/school/Field Trips and Excursions.png" alt />
                                </div>
                                <div className="facility-content">
                                    <h3 className="facility-title">
                                        <a to="#">Field Trips and Excursions</a>
                                    </h3>
                                    <p className="facility-text" style={{textAlign:"justify"}}>
                                       We organize regular visits to historical monuments, science centers, museums, nature parks, industries, educational institutions, and cultural sites. These trips help students connect theoretical knowledge with practical understanding, encouraging curiosity, creativity, and critical thinking.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="facility-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="facility-img">
                                    <img src="assets/school/Gallery_5.webp" alt />
                                </div>
                                <div className="facility-content">
                                    <h3 className="facility-title">
                                        <a to="#">Competitions and Events</a>
                                    </h3>
                                    <p className="facility-text" style={{textAlign:"justify"}}>
                                        Students actively participate in inter-school, district, and state-level competitions. Winners and participants are encouraged with certificates, medals, and prizes, boosting their confidence and motivation.
                                    </p>

                                </div>
                            </div>
                        </div>
                       
                       
                    </div>
                </div>
            </div>


        </>
    )
}

export default Activities